import { fromJS } from 'immutable';

import {
  CONTACT_US_EMAIL_SENT,
  CONTACT_US_EMAIL_SUCCESSFUL,
  GET_CONTACT_US_RECIPIENTS_SENT,
  GET_CONTACT_US_RECIPIENTS_SUCCESSFUL,
  GET_ADMIN_CONTACT_US_RECIPIENTS_SENT,
  GET_ADMIN_CONTACT_US_RECIPIENTS_SUCCESSFUL,
  CREATE_CONTACT_US_RECIPIENT_SENT,
  CREATE_CONTACT_US_RECIPIENT_SUCCESSFUL,
  UPDATE_CONTACT_US_RECIPIENT_SENT,
  UPDATE_CONTACT_US_RECIPIENT_SUCCESSFUL,
} from 'actions/atomic/contactUs';

const initialState = fromJS({
  emailSuccessful: false,
  loading: false,
  adminLoading: false,
  recipients: [],
  adminRecipients: [],
});

export default function contactUs(state = initialState, action) {
  switch (action.type) {
  case CONTACT_US_EMAIL_SENT:
    return state.set('emailSuccessful', false);
  case CONTACT_US_EMAIL_SUCCESSFUL:
    return state.set('emailSuccessful', true);
  case GET_CONTACT_US_RECIPIENTS_SENT:
    return state.merge({
      loading: true,
      recipients: fromJS([]),
    });
  case GET_CONTACT_US_RECIPIENTS_SUCCESSFUL:
    return state.merge({
      loading: false,
      recipients: fromJS(action.data),
    });
  case GET_ADMIN_CONTACT_US_RECIPIENTS_SENT:
    return state.merge({
      adminLoading: true,
      adminRecipients: fromJS([]),
    });
  case GET_ADMIN_CONTACT_US_RECIPIENTS_SUCCESSFUL:
    return state.merge({
      adminLoading: false,
      adminRecipients: fromJS(action.data),
    });
  case CREATE_CONTACT_US_RECIPIENT_SENT:
  case UPDATE_CONTACT_US_RECIPIENT_SENT:
    return state.set('adminLoading', true);
  case CREATE_CONTACT_US_RECIPIENT_SUCCESSFUL:
    return state.merge({
      adminLoading: false,
      adminRecipients: state.get('adminRecipients')
        .push(fromJS(action.data))
        .sortBy(recipient => recipient.get('position')),
    });
  case UPDATE_CONTACT_US_RECIPIENT_SUCCESSFUL:
    const updatedRecipient = action.data;
    const index = state.get('adminRecipients').findIndex(recipient => recipient.get('id') === updatedRecipient.id);
    const updatedRecipients = index === -1
      ? state.get('adminRecipients').push(fromJS(updatedRecipient))
      : state.get('adminRecipients').set(index, fromJS(updatedRecipient));
    return state.merge({
      adminLoading: false,
      adminRecipients: updatedRecipients.sortBy(recipient => recipient.get('position')),
    });
  default:
    return state;
  }
}
